package one.healthium.paywall.ui.components

import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.navigationBarsPadding
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.text.style.TextAlign
import androidx.compose.ui.unit.dp
import com.composables.core.SheetDetent.Companion.FullyExpanded
import com.composables.core.SheetDetent.Companion.Hidden
import loco.PAYWALL_OTHER_PLANS_BUTTON
import loco.Res
import kotlinx.coroutines.launch
import one.healthium.domain.paywall.models.PaywallOtherPlansView
import one.healthium.domain.paywall.models.ProductControl
import one.healthium.paywall.ui.models.ProductUiModel
import one.healthium.ui.compose.components.AppModalBottomSheet
import one.healthium.ui.compose.components.AppSheetTopBar
import one.healthium.ui.compose.components.AppTextButton
import one.healthium.ui.compose.components.rememberAppModalBottomSheetState
import one.healthium.ui.compose.theme.AppTheme
import org.jetbrains.compose.resources.stringResource

@Composable
fun PaywallOtherPlansView(
    model: PaywallOtherPlansView,
    products: List<ProductUiModel>,
    onClick: (ProductControl) -> Unit,
) {
    val config = model.config

    val sheetState = rememberAppModalBottomSheetState(initialDetent = Hidden)
    val scope = rememberCoroutineScope()

    Box(
        modifier = Modifier.fillMaxWidth(),
        contentAlignment = Alignment.Center,
    ) {
        AppTextButton(
            style = AppTheme.textStyles.textButtonGray,
            onClick = {
                sheetState.currentDetent = FullyExpanded
            }
        ) {
            Text(
                text = config.button ?: stringResource(Res.string.PAYWALL_OTHER_PLANS_BUTTON),
            )
        }
    }

    fun hideBottomSheet() {
        scope.launch { sheetState.animateTo(Hidden) }
    }
    AppModalBottomSheet(
        state = sheetState,
    ) {
        AppSheetTopBar(
            onCloseClicked = ::hideBottomSheet
        )
        if (!config.title.isNullOrBlank()) {
            Spacer(Modifier.height(16.dp))
            Text(
                modifier = Modifier
                    .fillMaxWidth()
                    .padding(horizontal = 24.dp),
                text = config.title ?: "",
                style = AppTheme.textStyles.titleMedium,
                color = AppTheme.colors.text100,
                textAlign = TextAlign.Center,
            )
            Spacer(Modifier.height(24.dp))
        }
        PlansControlsView(
            modifier = Modifier
                .fillMaxWidth()
                .padding(horizontal = 24.dp)
                .padding(bottom = 24.dp)
                .navigationBarsPadding(),
            controls = config.plans,
            products = products,
            selectedProductId = null,
            onClick = {
                hideBottomSheet()
                onClick(it)
            },
        )
    }
}
